import React from 'react';

// creating hook as it will be easier to mock separately

export function useAddressStateForLocationScreen() {
  const [address, setAddress] = React.useState();
  return [address, setAddress];
}
